// extracted by mini-css-extract-plugin
export var legendIndicator = "_dx-1";
export var legendRight = "_dx-0";